import { z } from 'zod'

export const idSchema = z.string().min(1)

export const paginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
})
export type Pagination = z.infer<typeof paginationSchema>

/** 어드민 표용 오프셋 페이지네이션 (page 는 1부터) */
export const pageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(20),
})
export type PageQuery = z.infer<typeof pageQuerySchema>

export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
})
export type ErrorResponse = z.infer<typeof errorResponseSchema>

/** 검색어 최대 글자 수 (커뮤니티 글 제목·본문, 내 제품 이름) */
export const SEARCH_QUERY_MAX = 60

/**
 * 검색어 질의 칸 (GET /community/posts · GET /simulations 의 q). 앱 검색 칸은 글자 수를 막지 않으므로 넘치면 400 대신
 * 앞 SEARCH_QUERY_MAX 글자로 자른다 — 400 이면 앱이 오류 없이 '검색 결과가 없어요' 를 띄운다 (QA 1.0.6).
 * 이모지가 반으로 잘리지 않게 글자(코드 포인트) 단위로 자른다
 */
export const searchQuerySchema = z
  .string()
  .trim()
  .min(1)
  .transform((q) => Array.from(q).slice(0, SEARCH_QUERY_MAX).join(''))
